import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import styles from "../styles/MiloWaitlistForm.module.css";

const MiloWaitlistForm = ({ setStep }) => {
  const [submitted, setSubmitted] = useState(false);
  const navigate = useNavigate();

  return (
    <div className={styles["miloWaitlistContainer"]}>
      <div className={styles["miloWaitlistMessage"]}>
        <h2>Should finding an apartment be any more complicated than that?</h2>
        <p>Join our waitlist and get early access to instant approvals.</p>
      </div>

        <button
          type="submit"
          className={styles["submitButton"]}
          onClick={() => {
            navigate("/waitlist");
          }}
        >
          Join the Waitlist
        </button>
    </div>
  );
};

export default MiloWaitlistForm;
